export * from './application.model';
export * from './attachment.model';
export * from './autocomplete-option.model';
export * from './case.model';
export * from './chip.model';
export * from './country.model';
export * from './dataset.model';
export * from './geological-sample.model';
export * from './label.model';
export * from './languages.model';
export * from './map-archive.model';
export * from './permission.model';
export * from './placename.model';
export * from './plankton.model';
export * from './record.model';
export * from './response.model';
export * from './role.model';
export * from './signal.model';
export * from './user.model';
export * from './vessel.model';
export * from './label.model';
export * from './geojson';

export const UrlPattern =
  /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#()?&//=]*)$/;
